import { FC, useState } from "react";
import { Button, HStack, Skeleton, Text } from "@chakra-ui/react";

import { unleashClient } from "../../../../../providers";
import { ExclamationMarkIcon, ReloadIcon } from "../../../../icons";

export const PaymentBlockCommissionError: FC = () => {
  const [isPending, setIsPending] = useState<boolean>(false);

  const onClick = async () => {
    setIsPending(true);

    try {
      await unleashClient.updateToggles();
    } finally {
      setIsPending(false);
    }
  };

  if (isPending) {
    return <Skeleton h="34px" mt="7px" />;
  }

  return (
    <HStack
      px="12px"
      py="7px"
      mt="7px"
      justifyContent="space-between"
      backgroundColor="red.25"
      borderRadius="12px"
    >
      <HStack spacing="6px">
        <ExclamationMarkIcon color="red.500" />

        <Text variant="brand" fontSize="12px">
          Не удалось получить комиссию
        </Text>
      </HStack>

      <Button minW="20px" h="20px" p="0" colorScheme="transparent" onClick={onClick}>
        <ReloadIcon color="red.500" />
      </Button>
    </HStack>
  );
};
